import {getCountryCode} from './get-country-code.js';

/**
 * ONLY TO BE USED IN LOCAL INTEGRATORS, DO NOT USE IN PROD
 * A Function to get languageTag with the language and marketId
 * @param language ISO 639-1:2002 language (e.g `'de'`)
 * @param marketId (e.g `'de'`)
 * @returns languageTag IETF BCP 47
 */
export function getLanguageTag(language: string, marketId: string): string {
  const languageLowerCase = language.toLowerCase();
  const countryCode = getCountryCode(marketId);
  const languageTag = `${languageLowerCase}-${countryCode}`;
  return languageTag;
}
